module.exports = __webpack_public_path__ + "img/dr-mark-mouw-mouw-family-chiropractic.bcfde92d.jpg";